@if (items().length > 0) {
  <mat-chip-listbox [value]="activeItemId()" (change)="onItemChange($event)">
    @for (item of items(); track item.id) {
      <mat-chip-option [value]="item.id">
        {{ item.name }}
        @if (controlFor(item.id); as ctrl) {
          @if (ctrl.invalid && ctrl.touched) {
            <span class="text-red-500 ml-0.5">*</span>
          }
        }
      </mat-chip-option>
    }
  </mat-chip-listbox>
  <mat-form-field class="w-full mt-3">
    <mat-label>{{ activeItemName() }}</mat-label>
    <input matInput [formControl]="activeControl()" />
  </mat-form-field>
}
